// Welche Seite wurde aufgerufen? Frontend-Spiegel von
// functions/shared/usageKeys.js - CRA laesst keine Importe ausserhalb von
// `src/` zu. `src/__tests__/usageKeysSync.test.js` ruft BEIDE Fassungen auf
// und vergleicht die Ergebnisse. Wer hier etwas aendert, aendert es DORT MIT.
//
// ── Warum eine feste Liste und nicht der Pfad ───────────────────────────
// Gezaehlt wird unter einem SCHLUESSEL aus dieser Liste, nie unter dem
// echten Pfad. Zwei Gruende, beide wichtig:
//
// 1. Datenschutz. `/intern/crew/0vXjgExn…` und `/termine/Kg4hadstMfj…`
//    enthalten IDs. Landeten die im Zaehler, staende in der Datenbank, wer
//    wessen Profil angesehen hat - genau das soll hier nicht entstehen.
//    Der Schluessel dafuer heisst `crew-profil`, ohne die uid.
// 2. Die Map bliebe sonst nicht beherrschbar. Jeder neue Termin waere ein
//    neuer Schluessel im Tagesdokument, und nach einem Jahr haette das
//    Dokument tausende Felder.
//
// Zugeordnet wird im BROWSER (der Server bekommt den rohen Pfad also gar
// nicht erst zu sehen), geprueft wird trotzdem noch einmal am Server -
// ein Client darf sich keinen eigenen Schluessel ausdenken.

/** Die Seiten, die getrennt gezaehlt werden. Reihenfolge = Anzeigereihenfolge. */
export const USAGE_PAGES = [
  { key: 'startseite', label: 'Startseite', bereich: 'oeffentlich' },
  { key: 'termine', label: 'Termine (öffentlich)', bereich: 'oeffentlich' },
  { key: 'termin-detail', label: 'Einzelner Termin', bereich: 'oeffentlich' },
  { key: 'stammtisch', label: 'Stammtisch-Seite', bereich: 'oeffentlich' },
  { key: 'galerie', label: 'Galerie', bereich: 'oeffentlich' },
  { key: 'mitmachen', label: 'Mitglied werden', bereich: 'oeffentlich' },
  { key: 'anmelden', label: 'Anmelden', bereich: 'oeffentlich' },
  { key: 'registrieren', label: 'Registrieren', bereich: 'oeffentlich' },
  { key: 'rechtliches', label: 'Impressum / Datenschutz', bereich: 'oeffentlich' },
  { key: 'intern-uebersicht', label: 'Übersicht', bereich: 'intern' },
  { key: 'intern-termine', label: 'Termine', bereich: 'intern' },
  { key: 'intern-termin-detail', label: 'Einzelner Termin', bereich: 'intern' },
  { key: 'intern-crew', label: 'Mitgliederliste', bereich: 'intern' },
  { key: 'intern-die-crew', label: 'Die Crew', bereich: 'intern' },
  { key: 'crew-profil', label: 'Profil eines Mitglieds', bereich: 'intern' },
  { key: 'intern-vernetzen', label: 'Vernetzen', bereich: 'intern' },
  { key: 'intern-karte', label: 'Karte', bereich: 'intern' },
  { key: 'intern-galerie', label: 'Galerie', bereich: 'intern' },
  { key: 'intern-merch', label: 'Merch', bereich: 'intern' },
  { key: 'intern-aushang', label: 'Aushang-Brett', bereich: 'intern' },
  { key: 'intern-profil', label: 'Mein Profil', bereich: 'intern' },
  { key: 'intern-ideen', label: 'Ideen', bereich: 'intern' },
  { key: 'intern-neuerungen', label: 'Neuerungen', bereich: 'intern' },
  { key: 'intern-organisieren', label: 'Organisieren', bereich: 'intern' },
  { key: 'intern-orga-werden', label: 'Orga werden', bereich: 'intern' },
  { key: 'admin', label: 'Admin-Bereich', bereich: 'admin' },
  { key: 'sonstiges', label: 'Sonstiges', bereich: 'oeffentlich' },
];

export const USAGE_PAGE_KEYS = USAGE_PAGES.map((p) => p.key);

export const USAGE_LABELS = USAGE_PAGES.reduce((acc, p) => {
  acc[p.key] = p.label;
  return acc;
}, {});

/** Die Ereignisse neben dem reinen Aufruf. */
export const USAGE_EVENTS = ['aufruf', 'login'];

/**
 * Pfad -> Schluessel. Reine Funktion.
 *
 * Reihenfolge zaehlt: Die spezifischeren Muster stehen VOR den allgemeinen,
 * sonst faengt `/intern/termine` auch `/intern/termine/abc` ab und die
 * Detailseite waere nicht mehr von der Liste zu unterscheiden.
 */
export function usagePageKey(pfad) {
  const p = String(pfad || '').split('?')[0].split('#')[0].replace(/\/+$/, '') || '/';

  if (p === '/') return 'startseite';
  if (p === '/termine') return 'termine';
  if (p.startsWith('/termine/')) return 'termin-detail';
  if (p.startsWith('/stammtisch/')) return 'stammtisch';
  if (p === '/galerie' || p.startsWith('/galerie/')) return 'galerie';
  if (p === '/mitmachen') return 'mitmachen';
  if (p === '/login') return 'anmelden';
  if (p === '/registrieren') return 'registrieren';
  if (p === '/impressum' || p === '/datenschutz') return 'rechtliches';

  if (p.startsWith('/admin')) return 'admin';

  if (p === '/intern') return 'intern-uebersicht';
  if (p === '/intern/termine') return 'intern-termine';
  if (p.startsWith('/intern/termine/')) return 'intern-termin-detail';
  if (p === '/intern/crew') return 'intern-crew';
  if (p === '/intern/die-crew') return 'intern-die-crew';
  if (p.startsWith('/intern/crew/')) return 'crew-profil';
  if (p === '/intern/vernetzen') return 'intern-vernetzen';
  if (p === '/intern/karte') return 'intern-karte';
  if (p === '/intern/galerie' || p.startsWith('/intern/galerie/')) return 'intern-galerie';
  if (p === '/intern/merch') return 'intern-merch';
  if (p === '/intern/aushang') return 'intern-aushang';
  if (p === '/intern/profil') return 'intern-profil';
  if (p === '/intern/ideen') return 'intern-ideen';
  if (p === '/intern/neuerungen') return 'intern-neuerungen';
  if (p === '/intern/organisieren') return 'intern-organisieren';
  if (p === '/intern/orga-werden') return 'intern-orga-werden';

  return 'sonstiges';
}

/** Ist das ein Schluessel, den wir kennen? Die Pruefung am Server. */
export function isUsagePageKey(key) {
  return USAGE_PAGE_KEYS.includes(key);
}

/**
 * Tagesschluessel `YYYY-MM-DD`, immer in Europe/Berlin.
 *
 * Bewusst NICHT die lokale Zeit des Rechners: Cloud Functions laufen in UTC,
 * der Browser in der Zeitzone des Besuchers. Mit `new Date().getDate()` fiele
 * ein Aufruf um 01:00 Uhr deutscher Sommerzeit serverseitig auf den Vortag -
 * die Tageskurve haette an jeder Mitternacht eine Naht. Ein Club in
 * Deutschland rechnet in deutscher Zeit, auf beiden Seiten dieselbe.
 *
 * `sv-SE` ist der kuerzeste Weg zu `YYYY-MM-DD` aus `Intl`.
 */
export function usageDayKey(datum = new Date()) {
  const d = datum instanceof Date ? datum : new Date(datum);
  return new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Europe/Berlin',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(d);
}

